<div class="px-24-px py-05-rem">
  <mat-button-toggle-group class="d-flex fd-row" (change)="optionTypeSelected($event)" [value]="defaultOption">
    <ng-container *ngFor="let option of typeOptions">
      <mat-button-toggle class="full-width text-weight-500 text-size-22 text-white" [value]="option.value">
        {{ option.text }}
      </mat-button-toggle>
    </ng-container>
  </mat-button-toggle-group>
</div>

<div class="d-flex fd-col overflow-y-auto custom-scrollbar px-24-px py-05-rem" tabindex="0">

  <div class="bg-color-background-1 d-flex mt-2">
    <div class="left-subtitle-block bg-color-primary-1"></div>
    <div class="d-flex full-width py-04">
      <sit-icon [icon]="Icon.speed" class="text-blue-1 ml-28" [sizeClass]="'icon-size-32'"
        alt="velocímetro icono título velocidad"></sit-icon>
      <h3 class="flex-grow text-weight-600 text-size-24 ml-16 text-md-size-18 text-white align-self-center">
        Velocidad
      </h3>
    </div>
  </div>

  <div class="d-flex">
    <div class="d-flex justify-space-around full-width py-container-speed">
      <div class="container-graphic-speed speed" [ngClass]="{'only-citizen':environment.citizen}">
        <sit-speedometer [properties]="avgSpeedProps"></sit-speedometer>
        <!-- <sit-custom-speedometer [speed]="17"></sit-custom-speedometer> -->
      </div>

      <div class="container-graphic-speed agreement" *ngIf="!environment.citizen">
        <sit-speedometer [properties]="avgConcordanceProps"></sit-speedometer>
      </div>
    </div>
  </div>

  <div *ngIf="!environment.citizen">
    <div class="bg-color-background-1 d-flex">
      <div class="left-subtitle-block bg-color-primary-1"></div>
      <div class="d-flex full-width py-04">
        <sit-icon [icon]="Icon.speed_range" class="text-blue-1 ml-28" [sizeClass]="'icon-size-32'"
          alt="velocímetro icono título rango de velocidad"></sit-icon>
        <h3 class="flex-grow text-weight-600 text-size-24 lh-32-px ml-16 text-md-size-18 text-white align-self-center">
          Rango de velocidad
        </h3>
      </div>
    </div>

    <div class="full-width h-400">
      <sit-chart-column [data]="listspeed" [id]="'speed-range'" [valueXAttrib]="'dta'" [disableXTooltip]="true"
        className="h-350"></sit-chart-column>
    </div>
  </div>

  <div class="bg-color-background-1 d-flex">
    <div class="left-subtitle-block bg-color-primary-1"></div>
    <div class="d-flex full-width py-04">
      <sit-icon [icon]="Icon.roads_w" class="text-blue-1 ml-28" [sizeClass]="'icon-size-32'"
        alt="camino icono título rutas principales"></sit-icon>
      <h3 class="flex-grow text-weight-600 text-size-24 ml-16 text-md-size-18 lh-32-px text-white align-self-center">
        Rutas principales
      </h3>
    </div>
  </div>

  <!-- <div class="table-title d-flex fd-row text-white text-weight-400 justify-space-around bg-color-secondary-4 py-10-px">
    <span>VELOCIDAD</span>
    <span>TIEMPO</span>
    <span>RANGO</span>
    <span>CONCORDANCIA</span>
  </div> -->

  <div class="list-cards gap-10-px py-24-px" [scrollHandler]="panelActionsDispatcher">
    <ng-container *ngFor="let card of cardList">
      <sit-card-traffic [card]="card"></sit-card-traffic>
    </ng-container>
  </div>
</div>
